// extracted by mini-css-extract-plugin
export default {"product":"yZ","image_carousel":"zZ","main_gallery":"AZ","personalized_badge":"BZ","greens_badge":"CZ","arrows":"EZ","slide":"FZ","thumbnail_gallery":"GZ","swiper-slide":"HZ","learn_more":"IZ","product_info":"JZ","description_wrapper":"KZ","checklist":"LZ","checklistItem":"MZ","delivery_freq":"NZ","tooltip_button":"OZ","key_benefits":"PZ","benefit_item":"QZ","ingredients":"RZ","ingredient_item":"SZ","active_slide":"TZ","benefits_list":"UZ","checkmark":"VZ"};
    if(module.hot) {
      // 1737143664036
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  